<template>
  <el-drawer :append-to-body="true" :modal-append-to-body="false" class="drawer" :visible.sync="drawer" direction="btt" size="auto" :show-close="false">
    <div class="content">
      <div class="content-head">
        <img :src="icons[0].src" :alt="icons[0].alt" @click="() => filter()">
        <span>Select a State</span>
      </div>
      <div class="content-body">
        <div class="current-loc" @click="() => filter('AL')">
          <img :src="icons[1].src"/>
          <span class="state-css">Current State: {{state.label}}</span>
        </div>
        <state-filter :filter="filter"></state-filter>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import StateFilter from "./state-filter";
export default {
  props: {
    query: {
      type: Object,
      default: () => {}
    },
    state: {
      type: Object
    }
  },
  components: {
    StateFilter
  },
  data() {
    return {
      drawer: false,
      icons: [
        {
          src: require('@/assets/icon/ic_return.svg'),
          alt: "return",
          width: "24px",
          height: "24px"
        },
        {
          src: require('@/assets/icon/ic_location.svg'),
          alt: "icon-view-poi"
        },
      ],
      value: ''
    }
  },
  watch: {
  },
  methods: {
    filter(state) {
      this.$emit('filter', state)
      this.drawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: SFProText-Semibold;
    src: url(../../../assets/fonts/SF-Pro-Text-Bold.otf);
}
.drawer {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
  height: 100%;
  // z-index: 1000;
  background-color: #ffffff;
  /deep/.el-drawer.btt{
    top: 0;
  }
  /deep/ .el-drawer__container {
    position: relative;
    .el-drawer__header {
      position: absolute;
      top: 44px;
      right: 44px;
      margin: 0;
      padding: 0;
      .el-dialog__close {
        font-size: 32px;
      }
    }
    .el-drawer__body {
      overflow-y: scroll;
      background-color: rgb(246, 247, 250);
    }
  }
  .content {
    overflow-y: overlay;

    .content-head {
      width: 100%;
      position: relative;
      text-align: center;
      background-color: #ffffff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        position: absolute;
        left: 15px;
        top: 12px;
        width: 24px;
      }

      span {
        font-family: SFProText-Semibold;
        display: inline-block;
        font-size: 14px;
        line-height: 22px;
        color: rgb(20, 26, 66);
      }
      margin-bottom: 10px;
    }

    .content-body {
      .current-loc {
        width: 100%;
        position: relative;
        background-color: #ffffff;
        padding: 10px;
        text-align: start;
        font-family: SFProText-Semibold;
        display: flex;
        align-items: center;
        .state-css {
          color: #168cd8;
          font-size: 14px;
          line-height: 20px;
          margin-left: 20px;
        }

        img {
          position: absolute;
        }
      }
    }
  }
}
</style>
